// eslint-disable-next-line import/prefer-default-export
export const MODAL_TYPES = {
  MOVE_MODAL: 'move_modal',
  REMOVE_MODAL: 'remove_modal',
  BLACKLIST_MODAL: 'blacklist_modal',
  DELETE_MODAL: 'delete_modal',
  MARK_AS_FINISHED_MODAL: 'mark_as_finished_modal',
  UNMARK_AS_FINISHED_MODAL: 'unmark_as_finished_modal',
};
